// extracted by mini-css-extract-plugin
export var slide = "styles-module--slide--Ro6Vq";
export var slide_top = "styles-module--slide_top--3-5u6";
export var slide_number = "styles-module--slide_number--30RNR";
export var slide_main = "styles-module--slide_main--38-GQ";
export var slide_main_question = "styles-module--slide_main_question--3-gTa";
export var slide_main_answer = "styles-module--slide_main_answer--3eS69";